export const CREATE_PLC_SAFETY_ZONE_DEPENDENCY = 'CREATE_PLC_SAFETY_ZONE_DEPENDENCY';
export const CREATE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL = 'CREATE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL';
export const CREATE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED = 'CREATE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED';
